import { render, staticRenderFns } from "./OtherScars.vue?vue&type=template&id=55f4e6ad"
import script from "./OtherScars.vue?vue&type=script&lang=js"
export * from "./OtherScars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports